import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.516 2.16568C12.3767 2.03359 12.192 1.95996 12 1.95996C11.808 1.95996 11.6233 2.03359 11.484 2.16568C9.36128 4.18156 6.53413 5.28701 3.60701 5.24568C3.44754 5.24361 3.29157 5.29242 3.16173 5.38503C3.0319 5.47764 2.93496 5.60923 2.88501 5.76068C2.46298 7.04684 2.24862 8.39205 2.25001 9.74568C2.25001 15.6877 6.31401 20.6787 11.813 22.0937C11.9357 22.1253 12.0643 22.1253 12.187 22.0937C17.686 20.6787 21.75 15.6877 21.75 9.74568C21.75 8.35568 21.527 7.01568 21.115 5.76068C21.0652 5.60904 20.9684 5.47723 20.8385 5.38443C20.7087 5.29163 20.5526 5.24267 20.393 5.24468L20.25 5.24568C17.254 5.24568 14.533 4.07568 12.516 2.16568ZM12.0002 7.11548C14.8154 7.11548 12.0002 15.4843 12.0002 15.4843C12.0002 15.4843 9.18501 7.11548 12.0002 7.11548ZM11.25 16.9867C11.25 16.5725 11.5858 16.2367 12 16.2367H12.008C12.4222 16.2367 12.758 16.5725 12.758 16.9867V16.9947C12.758 17.4089 12.4222 17.7447 12.008 17.7447H12C11.5858 17.7447 11.25 17.4089 11.25 16.9947V16.9867Z"
        fill={colorValue}
      />
    </svg>
  );
};
